import { DashboardState, DashboardAction, DashboardActionTypes } from './dashboardTypes';

const initialState: DashboardState = {
  loading: true,
  panelsData: null,
};

export default function dashboardReducer(
  state = initialState,
  action: DashboardAction,
): DashboardState {
  switch (action.type) {
    case DashboardActionTypes.GET_PANELS_DATA_START:
      return {
        ...state,
        loading: true,
      };

    case DashboardActionTypes.GET_PANELS_DATA_SUCCESS:
      if (!action.panelsData) {
        throw new Error();
      }
      return {
        ...state,
        loading: false,
        panelsData: action.panelsData,
      };

    case DashboardActionTypes.GET_PANELS_DATA_ERROR:
      return {
        ...state,
        loading: true,
      };

    default:
      return state;
  }
}
